"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitstraySantasSeederFactory = void 0;
const contracts_1 = require("@ethersproject/contracts");
class BitstraySantasSeederFactory extends contracts_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static connect(address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BitstraySantasSeederFactory = BitstraySantasSeederFactory;
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitstrayId",
                type: "uint256",
            },
            {
                internalType: "contract IBitstraysDescriptor",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "generateSeed",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "arms",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "shirt",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "motive",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "eyes",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "mouth",
                        type: "uint48",
                    },
                ],
                internalType: "struct IBitstraysSeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
